export default "__VITE_ASSET__CqbozHy0__"